import * as actions from '../live-nurses.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';

export interface SubmittalState {
    loading: LoadingTypes;
    success: boolean;
}

const initialState: SubmittalState = {
    loading: LoadingTypes.INIT,
    success: false
};

export function liveNursesSubmittalReducer(state: SubmittalState, action: Action) {
    return createReducer(
        initialState,
        on(actions.deleteSubmittal, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING,
            success: false
        })),

        on(actions.deleteSubmittalSuccess, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED,
            success: true
        })),

        on(actions.deleteSubmittalFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED,
            success: false
        }))
    )(state, action);
}

export function reducer(state: SubmittalState | undefined, action: Action) {
    return liveNursesSubmittalReducer(state, action);
}
